const config = {
  apiUrl: process.env.REACT_APP_ENV === 'production' 
    ? 'https://guru.aistrat.app' 
    : 'https://app.aistrat.app',
  environment: process.env.REACT_APP_ENV || 'staging'
};

export default config;
